// @flow strict
import * as React from 'react'

import {
  MainNavigation,
  USNavigation,
  LegacyFooter,
  USFooter,
  type PropsWithChildren,
  SEOHead,
  CookieAlert,
} from '@mondough/public-web-components'

import './Global.module.scss'

type GlobalProps = {
  pageMetadata: React.Element<typeof SEOHead>,
  isUSPage?: boolean,
}

const Global = ({
  children,
  pageMetadata,
  isUSPage,
}: PropsWithChildren<GlobalProps>) => (
  <>
    {pageMetadata}
    <CookieAlert />
    {isUSPage ? <USNavigation /> : <MainNavigation />}
    <main role="main">{children}</main>
    {isUSPage ? <USFooter /> : <LegacyFooter />}
  </>
)

export default Global
